/* eslint-disable react-hooks/exhaustive-deps */
import ConfigurableTable from 'components/shared/table/ConfigurableTable';
import { searchData } from 'utils/utils';

import GNESearch from 'components/shared/search/GNESearch';
import { useEffect, useState } from 'react';
import { Col, Row, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import LinkButton from 'components/shared/button/LinkButton';
import { DOCUMENT_COLUMNS } from 'constants/constants';
import { getDocuments } from 'services/document.service';
import OverlayTrigger from 'components/shared/tooltip/Tooltip';

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [origalDocuments, setOriginalDocuments] = useState([]);
  const [searchText, setSearchText] = useState('');
  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);

  useEffect(() => {
    (async () => {
      // get the documents
      const docs = await getDocuments(unixId, roleId);
      setDocuments(docs);
      setOriginalDocuments(docs);
    })();
  }, []);

  const handleSearch = (value) => {
    const filteredData = searchData(origalDocuments, value);
    setSearchText(value);
    setDocuments(filteredData);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);
  };
  const emailClickHandler = async (record) => {
    window.open(
      'https://mail.google.com/mail/?view=cm&fs=1&to=' + record.PocEmail,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const sortData = () => {};
  const size = { x: 800 };
  const tooltip = () => {
    return (
      <Tooltip className='gne-tooltip'>
        <span className='text text__x-small'>
          {`Request new reports under Help->Raise a Request. For outdated reports or specific questions about reports, contact the listed point of contact for clarification.`}
        </span>
      </Tooltip>
    );
  };

  return (
    <>
      <Row className='align-items-center m-4 d-flex justify-content-between'>
        <Col sm={4}>
          <GNESearch
            placeholder='Search'
            onSearch={handleSearch}
            value={searchText}
            onChange={handleSearchChange}
            onClear={handleSearch}
          />
        </Col>
        <Col
          sm={4}
          className='text-end'>
          <OverlayTrigger overlay={tooltip()}>
            <i className={`icon icon__info_icon-yellow`} />
          </OverlayTrigger>
          <span className='text text__bold text__small mb-4 '>
            Missing Reports?
          </span>
        </Col>
      </Row>

      <div className='mt-4'>
        <ConfigurableTable
          rows={documents}
          columns={DOCUMENT_COLUMNS}
          expandRowByClick={false}
          enableColumnSelection={false}
          tableName='document'
          showActionIcon={true}
          onActionClickHandler={emailClickHandler}
          iconProps={{ iconCss: 'e-mail' }}
          pagination={false}
          isGlobalSort={true}
          onSort={sortData}
          dimentions={size}
          actionColumnTitle='Actions'
        />
      </div>
    </>
  );
};

export default Documents;
